export default __webpack_public_path__ + "69585615812f54b67e14f23de8042440.svg";